import type OriginalVue from 'vue';
import appName from '../helpers/appName';

declare module 'vue' {
  interface ComponentCustomProperties {
    $appName: string;
  }
}

/**
 * Exposes the product name as `this.$appName` in every component.
 *
 * A branded app carries its own name, and the copy has to follow it: inside such an app
 * GrainFox is only named in the 'powered by' lockup, never as the product. The name is
 * fixed for the whole visit, so it is read straight from the server's page payload.
 */
export default {
  install: (Vue: typeof OriginalVue): void => {
    Object.defineProperty(Vue.prototype, '$appName', {
      get: appName,
      configurable: true,
    });
  },
};
